module.exports = __webpack_public_path__ + "static/media/UY.31bef519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/UY.svg
// module id = 2285
// module chunks = 7